import {
    UPDATE_RESIDENT,
    UPDATE_INVESTMENT_YEARS,
    UPDATE_INVESTMENT_PROFILE,
    UPDATE_TEMPORARY_DROP_PERCENTAGE,
    UPDATE_DEPENDANTS,UPDATE_ADDRESSLINE
  } from './actionsTypes';
  import { createAction } from '@reduxjs/toolkit';

  
  export const updateResident = (resident) => ({ type: UPDATE_RESIDENT, payload: resident });
  export const updateInvestmentYears = (years) => ({ type: UPDATE_INVESTMENT_YEARS, payload: years });
  export const updateInvestmentProfile = (profile) => ({ type: UPDATE_INVESTMENT_PROFILE, payload: profile });
  export const updateTemporaryDropPercentage = (percentage) => ({ type: UPDATE_TEMPORARY_DROP_PERCENTAGE, payload: percentage });
  export const updateDependants = (percentage) => ({ type: UPDATE_DEPENDANTS, payload: percentage });
  export const updateAddressLine = (fullAddress) => ({type: UPDATE_ADDRESSLINE,payload: fullAddress,
  });
  export const updateLoginToken = createAction('loginToken/setLoginToken'); // Updated action creator